exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper-button-next,.swiper-button-prev{margin-top:0;top:0;width:150px;height:100%}@media screen and (max-width:576px){.swiper-button-next,.swiper-button-prev{background-image:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c67ce8c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/page/widgets/ImageSliderWidget.vue
// module id = 66
// module chunks = 0 1 2